import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type SignUpDto = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
};

export const signUp = async (data: SignUpDto) => {
  const { email, password } = data;

  const response = await api.auth.signUp.mutation({
    body: {
      email,
      password,
    },
  });

  if (response.status === 201) {
    return response.body;
  }

  if (response.status === 400) {
    throw new ApiError(response.body.message, response.status, response.body);
  }

  throw new ApiError("Can't create account", response.status, response.body);
};
